import React from 'react';
import { useIntl } from 'react-intl';

import { FormItemAutocomplete } from '../../../../components/forms/selects';

export default function AirportAutoComplete({
  name,
  airports,
  rules,
  isLoading,
  isArrival = true,
}) {
  const { formatMessage } = useIntl();

  return (
    <FormItemAutocomplete
      name={name}
      rules={rules}
      options={airports || []}
      floatingLabel={false}
      autofillFromOptions={false}
      formItemComponentProps={{
        formatLabel: x => (x?.code ? `${x?.code} - ${x?.text}` : x?.text),
      }}
      placeholder={formatMessage({
        id: `book.newAirRetrieval.${isArrival ? 'arrivalAirport' : 'departureAirport'}.placeholder`,
      })}
      mapOptions={options =>
        options?.map(airport => ({
          code: airport.airport,
          label: airport.airportName,
          value: {
            ...airport,
            code: airport.airport,
            text: airport.airportName,
          },
        })) || []
      }
      loading={isLoading}
    />
  );
}
